import {
  FiGrid, FiUser, FiShield, FiCalendar, FiTruck,
  FiBriefcase, FiFileText, FiBarChart2,
  FiMessageCircle, FiMapPin, FiPackage, FiUsers,
  FiDollarSign, FiPlusCircle, FiLock,
} from "react-icons/fi";

export const SECTIONS = [
  {
    key: "overview",
    label: "Overview",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: FiGrid },
    ],
  },

  {
    key: "master",
    label: "Master",
    items: [
      { to: "/city", label: "City", icon: FiMapPin },
      { to: "/packages", label: "Packages", icon: FiPackage },
      { to: "/drivers", label: "Drivers", icon: FiUsers, perm: "DRIVERS_READ" },
      // Fleet and Vehicle Categories are two tabs of this one master.
      { to: "/vehicles", label: "Vehicles", icon: FiTruck, perm: "VEHICLES_READ" },
      { to: "/enterprises", label: "Enterprises", icon: FiBriefcase, perm: "ENTERPRISES_READ" },
      { to: "/pricing", label: "B2C Pricing", icon: FiDollarSign, perm: "PRICING_READ" },
      { to: "/comms-templates", label: "Comms Templates", icon: FiMessageCircle },
    ],
  },

  {
    key: "ops",
    label: "Operational",
    items: [
      { to: "/create-booking", label: "Create Booking", icon: FiPlusCircle, perm: "BOOKINGS_CREATE" },
      { to: "/bookings", label: "Bookings", icon: FiCalendar, perm: "BOOKINGS_READ" },
      { to: "/invoices", label: "Invoices", icon: FiFileText, perm: "INVOICES_READ" },
      { to: "/reports", label: "Reports", icon: FiBarChart2, perm: "REPORTS_READ" },
    ],
  },

  {
    key: "admin",
    label: "Admin",
    items: [
      { to: "/users", label: "Users", icon: FiUser, perm: "USERS_READ" },
      { to: "/permissions", label: "Roles & Permissions", icon: FiShield, perm: "ROLES_READ" },
    ],
  },
];

export const NAV_BOTTOM = [
  { to: "/privacy-policy", label: "Privacy Policy/Disclaimer", icon: FiLock }
];
